import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DisplayMenuSectionBodyComponent } from '../../../display-menu-section/display-menu-section-body/display-menu-section-body.component';

@Component({
  selector: 'app-display-menu-section-inside-template-collection-body',
  templateUrl: './display-menu-section-inside-template-collection-body.component.html',
  styleUrls: ['./display-menu-section-inside-template-collection-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DisplayMenuSectionInsideTemplateCollectionBodyComponent extends DisplayMenuSectionBodyComponent {
  constructor() {
    super();
  }
}
